export enum StatementCategoryOperationEnum
{
	None = "None",
	NewInformation = "NewInformation",
	ClarifyInformation = "ClarifyInformation",
	RemoveInformation = "RemoveInformation"
}
